import { Http } from './Http';
import { NetworkError } from './models/NetworkError';
import { MimeType } from './enums/MimeType';
import { AxiosError } from 'axios';
import { useLogs } from '~~/composables/useLogs';

export class BlobClient {
  private endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  // HTTP calls
  public async fetch(): Promise<Blob> {
    try {
      const apiServerBlobClient = await new Http().apiServerBlobClient();
      const response = await apiServerBlobClient.get(this.endpoint);
      return response.data;
    } catch (error) {
      useLogs().trackException(error as Error);
      throw await new NetworkError(error as AxiosError).handle();
    }
  }

  public async fetchFromClientPublicDirectory(): Promise<Blob> {
    try {
      const directoryBlobClient = await new Http().publicDirectoryBlobClient();
      const response = await directoryBlobClient.get(this.endpoint);
      return response.data;
    } catch (error) {
      useLogs().trackException(error as Error);
      throw await new NetworkError(error as AxiosError).handle();
    }
  }

  // Downloads
  public async fetchAndDownload(fileName: string, fileType: MimeType): Promise<void> {
    const link = document.createElement('a');
    link.download = fileName;

    const blob = await this.fetch();
    const file = new Blob([blob], {
      type: fileType,
    });

    link.href = URL.createObjectURL(file);
    link.click();
    URL.revokeObjectURL(link.href);
    link.remove();
  }

  public async fetchAndDownloadFromPublicDirectory(fileName: string): Promise<void> {
    const link = document.createElement('a');

    link.download = `${fileName}.xlsx`;
    const blob = await this.fetchFromClientPublicDirectory();
    const file = new Blob([blob], { type: MimeType.EXCEL });

    link.href = URL.createObjectURL(file);
    link.click();

    URL.revokeObjectURL(link.href);
    link.remove();
  }
}
